import { setupLocale } from "../localizationManager";

export var farsiStrings = {
  // "Group By Me"
  groupButton: "گروه بندی با",
  // "Ungroup By Me"
  ungroupButton: "حذف گروه",
  // "Select Me"
  selectButton: "انتخاب",
  // [Auto-translated] "Column reorder"
  columnReorder: "بازآرایی ستون ها",
  // "Hide column"
  hideColumn: "مخفی کردن ستون",
  // "Show column"
  showColumn: "نمایش ستون",
  // [Auto-translated] "Columns"
  columns: "ستون ها",
  // "Make column private"
  makePrivateColumn: "خصوصی کردن ستون",
  // "Make column public"
  makePublicColumn: "عمومی کردن ستون",
  // "Move to Detail"
  moveToDetail: "انتقال به جزئیات",
  // "Show as Column"
  showAsColumn: "نمایش به عنوان ستون",
  // "Search..."
  filterPlaceholder: "جستجو...",
  // "Remove rows"
  removeRows: "حذف سطرها",
  // "Show"
  showLabel: "نمایش",
  // "entries"
  entriesLabel: "ورودی",
  // [Auto-translated] "Entries on Page:"
  entriesOnPageLabel: "ورودی ها در صفحه:",
  // "Texts in table"
  visualizer_text: "متون در جدول",
  // "Wordcloud"
  visualizer_wordcloud: "ابر کلمات",
  // "Histogram"
  visualizer_histogram: "هیستوگرام",
  // "Average"
  visualizer_number: "متوسط",
  // [Auto-translated] "Average"
  visualizer_average: "میانگین",
  // "Table"
  visualizer_choices: "جدول",
  // "Chart"
  visualizer_selectBase: "نمودار",
  // [Auto-translated] "Chart"
  visualizer_matrix: "نمودار",
  // [Auto-translated] "Bar"
  chartType_bar: "نوار",
  // "Vertical Bar"
  chartType_vbar: "نوار عمودی",
  // "Stacked Bar"
  chartType_stackedbar: "نوار پشته",
  // "Doughnut"
  chartType_doughnut: "دونات",
  // "Pie"
  chartType_pie: "دابره ای(pie)",
  // "Scatter"
  chartType_scatter: "پراکندگی(Scatter)",
  // "Gauge"
  chartType_gauge: "عقربه ای",
  // [Auto-translated] "Bullet"
  chartType_bullet: "بولت",
  // [Auto-translated] "Line"
  chartType_line: "خط",
  // [Auto-translated] "Radar"
  chartType_radar: "رادار",
  // [Auto-translated] "Histogram"
  chartType_histogram: "هیستوگرام",
  // [Auto-translated] "Vertical Histogram"
  chartType_vhistogram: "هیستوگرام عمودی",
  // [Auto-translated] "Stacked Histogram"
  chartType_stackedhistogram: "هیستوگرام انباشته شده",
  // "Hide"
  hideButton: "مخفی",
  // "Make private"
  makePrivateButton: "خصوصی کردن",
  // "Make public"
  makePublicButton: "عمومی کردن",
  // "Show"
  showButton: "نمایش",
  // "Filter"
  filter: "فیلتر",
  // "Reset Filter"
  resetFilter: "بازنشانی فیلترها",
  // "Change Locale"
  changeLocale: "تغییر محلی",
  // "Clear"
  clearButton: "پاک کردن",
  // "Choose question to show..."
  addElement: "انتخاب سوال برای نمایش...",
  // [Auto-translated] "All questions"
  allQuestions: "همه سوالات",
  // [Auto-translated] "Select all"
  selectAll: "همه را انتخاب کنید",
  // [Auto-translated] "Clear selection"
  clearSelection: "انتخاب شفاف",
  // "Default Order"
  defaultOrder: "ترتیب پیشفرض",
  // "Ascending"
  ascOrder: "صعودی",
  // "Descending"
  descOrder: "نزولی",
  // "Show minor columns"
  showMinorColumns: "نمایش ستونهای فرعی",
  // [Auto-translated] "Actions"
  actionsColumn: "اقدامات",
  // "Other items and comments"
  otherCommentTitle: "سایر موارد و نظرات",
  // "Show percentages"
  showPercentages: "نمایش درصد",
  // "Hide percentages"
  hidePercentages: "درصدهای مخفی",
  // [Auto-translated] "Export As..."
  exportAs: "صادرات به عنوان...",
  // "PDF"
  pdfDownloadCaption: "پی دی اف",
  // "Excel"
  xlsxDownloadCaption: "اکسل",
  // "CSV"
  csvDownloadCaption: "Csv",
  // [Auto-translated] "Export as PDF"
  pdfDownloadHint: "صادرات به صورت PDF",
  // [Auto-translated] "Export as Excel"
  xlsxDownloadHint: "صادرات به صورت اکسل",
  // [Auto-translated] "Export as CSV"
  csvDownloadHint: "صادرات به صورت CSV",
  // "Download plot as a PNG file"
  saveDiagramAsPNG: "دانلود طرح به عنوان یک فایل PNG",
  // [Auto-translated] "response(s)"
  responsesText: "پاسخ(ها)",
  // [Auto-translated] "No data"
  noData: "داده ای وجود ندارد",
  // [Auto-translated] "Select date range..."
  selectDateRange: "بازه زمانی را انتخاب کنید...",
  // [Auto-translated] "Start date"
  startDate: "تاریخ شروع",
  // [Auto-translated] "End date"
  endDate: "تاریخ پایان",
  // [Auto-translated] "Include today"
  includeToday: "امروز را شامل کنید",
  // [Auto-translated] "Custom"
  reportingPeriodCustom: "عرف",
  // [Auto-translated] "Last 7 days"
  reportingPeriodLast7days: "۷ روز آخر",
  // [Auto-translated] "Last 14 days"
  reportingPeriodLast14days: "۱۴ روز آخر",
  // [Auto-translated] "Last 28 days"
  reportingPeriodLast28days: "۲۸ روز آخر",
  // [Auto-translated] "Last 30 days"
  reportingPeriodLast30days: "۳۰ روز آخر",
  // [Auto-translated] "Last week (starts Monday)"
  reportingPeriodLastWeekMon: "هفته گذشته (از دوشنبه شروع می شود)",
  // [Auto-translated] "Last week (starts Sunday)"
  reportingPeriodLastWeekSun: "هفته گذشته (از یکشنبه شروع می شود)",
  // [Auto-translated] "Last month"
  reportingPeriodLastMonth: "ماه گذشته",
  // [Auto-translated] "Last quarter"
  reportingPeriodLastQuarter: "سه ماهه آخر",
  // [Auto-translated] "Last year"
  reportingPeriodLastYear: "سال گذشته",
  // [Auto-translated] "This week to date (starts Sunday)"
  reportingPeriodWtdSun: "این هفته تا به امروز (از یکشنبه شروع می شود)",
  // [Auto-translated] "This week to date (starts Monday)"
  reportingPeriodWtdMon: "این هفته تا به امروز (از دوشنبه شروع می شود)",
  // [Auto-translated] "This month to date"
  reportingPeriodMtd: "این ماه تا به امروز",
  // [Auto-translated] "This quarter to date"
  reportingPeriodQtd: "این سه ماهه تا به امروز",
  // [Auto-translated] "This year to date"
  reportingPeriodYtd: "امسال تا به امروز",
  // "Hide empty answers"
  hideEmptyAnswers: "مخفی کردن پاسخهای خالی",
  // "Show empty answers"
  showEmptyAnswers: "نمایش پاسخهای خالی",
  // "All answers"
  "topNValueText-1": "همه پاسخ ها",
  // "Top 5 answers"
  topNValueText5: "5 پاسخ برتر",
  // "Top 10 answers"
  topNValueText10: "10 پاسخ برتر",
  // "Top 20 answers"
  topNValueText20: "20 پاسخ برتر",
  // "Hide missing answers"
  hideMissingAnswers: "مخفی کردن پاسخهای گمشده",
  // "Show missing answers"
  showMissingAnswers: "نمایش پاسخهای گمشده",
  // "Missing answers"
  missingAnswersLabel: "پاسخ های گمشده",
  // "This question type is not visualized yet"
  noVisualizerForQuestion: "این نوع سوال هنوز تجسم نشده است",
  // "There are no results yet"
  noResults: "هنوز نتیجه ای حاصل نشده است",
  // "Per Values"
  showPerValues: "به ازای هر ارزش",
  // "Per Columns"
  showPerColumns: "در هر ستون",
  // "Answer"
  answer: "پاسخ",
  // "Correct answer: "
  correctAnswer: "پاسخ صحیح: ",
  // [Auto-translated] "Percentage"
  percentage: "درصد",
  // [Auto-translated] "Chart"
  statistics_chart: "نمودار",
  // "Responses"
  responses: "پاسخ",
  // [Auto-translated] "Total responses"
  totalResponses: "پاسخ های کلی",
  // [Auto-translated] "NPS"
  visualizer_nps: "NPS",
  // [Auto-translated] "Chart"
  visualizer_boolean: "نمودار",
  // [Auto-translated] "Table"
  visualizer_options: "جدول",
  // [Auto-translated] "NPS"
  npsScore: "NPS",
  // [Auto-translated] "Promoters"
  npsPromoters: "مروج",
  // [Auto-translated] "Passives"
  npsPassives: "منفعل ها",
  // [Auto-translated] "Detractors"
  npsDetractors: "بدهیدان",
  // [Auto-translated] "Category (X Axis)"
  axisXSelectorTitle: "دسته بندی (محور X)",
  // [Auto-translated] "Legend (Series)"
  axisYSelectorTitle: "افسانه (مجموعه)",
  // [Auto-translated] "Segments:"
  axisXAlternativeSelectorTitle: "بخش:",
  // [Auto-translated] "Groups:"
  axisYAlternativeSelectorTitle: "گروه:",
  // [Auto-translated] "Not selected"
  notSelected: "انتخاب نشده",
  // [Auto-translated] "Secondary Y axis"
  secondYAxisToggleTitle: "محور دوم Y",
  // [Auto-translated] "Select a data field..."
  selectDataField: "یک فیلد داده انتخاب کنید...",
  // [Auto-translated] "Default"
  intervalMode_default: "پیش فرض",
  // [Auto-translated] "Decades"
  intervalMode_decades: "دهه",
  // [Auto-translated] "Years"
  intervalMode_years: "سال",
  // [Auto-translated] "Quarters"
  intervalMode_quarters: "چهارم",
  // [Auto-translated] "Months"
  intervalMode_months: "ماه‌ها",
  // [Auto-translated] "Days"
  intervalMode_days: "روز‌ها",
  // [Auto-translated] "Auto"
  intervalMode_auto: "خودکار",
  // [Auto-translated] "Intervals:"
  intervalModeTitle: "فواصل:",
  // [Auto-translated] "Show individual values"
  noRunningTotals: "نمایش ارزش های فردی",
  // [Auto-translated] "Show running totals"
  runningTotals: "نمایش مجموع در حال اجرا",
  // [Auto-translated] "Compare periods"
  groupDateSeries: "دوره ها را مقایسه کنید",
  // [Auto-translated] "View timeline"
  ungroupDateSeries: "مشاهده جدول زمانی",
  // [Auto-translated] "None"
  noneAggregateText: "هیچ کدام",
  // [Auto-translated] "Aggregate:"
  selectAggregateText: "مجموع:",
  // [Auto-translated] "Year ends with"
  groupedYearsAxisTitle: "سال به پایان می رسد با",
  // [Auto-translated] "Series {0}"
  seriesListSeries: "سری {0}",
  // [Auto-translated] "Values"
  seriesListValuesLabel: "ارزش ها",
  // [Auto-translated] "Remove"
  seriesListRemove: "حذف",
  // [Auto-translated] "Add Series"
  seriesListAdd: "سری Add",
  // [Auto-translated] "Move to second axis"
  seriesListMoveToSecondAxis: "حرکت به محور دوم",
  // [Auto-translated] "Move to first axis"
  seriesListMoveToFirstAxis: "حرکت به محور اول",
  // [Auto-translated] "Count"
  aggregationCount: "کنت",
  // [Auto-translated] "Sum"
  aggregationSum: "جمع",
  // [Auto-translated] "Average"
  aggregationAverage: "میانگین",
  // [Auto-translated] "Close"
  close: "بسته شدن",
  // [Auto-translated] "K"
  thousandsSuffix: "هزار",
  // [Auto-translated] "M"
  millionsSuffix: "میلیون",
  // [Auto-translated] "B"
  billionsSuffix: "میلیارد"
};

setupLocale({ localeCode: "fa", strings: farsiStrings, nativeName: "فارسی" });
